import type { ReactNode } from 'react'
import { ExampleChip } from './ExampleChip'
import s from './PageHeader.module.css'

/**
 * The top of every screen: the title, one line on what it shows, chips (Example data, Updating) and actions.
 * <Screen> draws it for you from its props.
 */
export function PageHeader(props: {
  title: string
  description?: string
  example?: boolean
  /** "As of 2:14 pm", or any short note on how fresh the numbers are. */
  meta?: string
  chips?: ReactNode
  actions?: ReactNode
}) {
  return (
    <header className={s.header}>
      <div className={s.text}>
        <div className={s.titleRow}>
          <h1 className={s.title}>{props.title}</h1>
          {props.example && <ExampleChip />}
          {props.chips}
        </div>
        {(props.description || props.meta) && (
          <p className={s.description}>
            {props.description}
            {props.description && props.meta ? ' ' : ''}
            {props.meta && <span className={s.meta}>{props.meta}</span>}
          </p>
        )}
      </div>
      {props.actions && <div className={s.actions}>{props.actions}</div>}
    </header>
  )
}
